export default {
    download(objectUrl, fileName){
        var link = document.createElement('a');
        link.href = objectUrl;
        link.download = fileName;
        link.click();
    }
}